import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetPropertyOriginDestinationsInputDto, PropertyOriginDestinationCreateDto, PropertyOriginDestinationDto, PropertyOriginDestinationExcelDownloadDto, PropertyOriginDestinationUpdateDto } from '../dtos/property-origin-destination/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class PropertyOriginDestinationService {
  private restService = inject(RestService);
  apiName = 'Geographic';
  

  create = (input: PropertyOriginDestinationCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PropertyOriginDestinationDto>({
      method: 'POST',
      url: '/api/geographic/propertyOriginDestinations',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/geographic/propertyOriginDestinations/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/geographic/propertyOriginDestinations',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PropertyOriginDestinationDto>({
      method: 'GET',
      url: `/api/geographic/propertyOriginDestinations/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/geographic/propertyOriginDestinations/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetPropertyOriginDestinationsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<PropertyOriginDestinationDto>>({
      method: 'GET',
      url: '/api/geographic/propertyOriginDestinations',
      params: { destinationLocationId: input.destinationLocationId, originLocationId: input.originLocationId, propertyLocationId: input.propertyLocationId, distance: input.distance, distanceFrom: input.distanceFrom, distanceTo: input.distanceTo, unPavedRoadDistance: input.unPavedRoadDistance, unPavedRoadDistanceFrom: input.unPavedRoadDistanceFrom, unPavedRoadDistanceTo: input.unPavedRoadDistanceTo, pavedRoadDistance: input.pavedRoadDistance, pavedRoadDistanceFrom: input.pavedRoadDistanceFrom, pavedRoadDistanceTo: input.pavedRoadDistanceTo, tollCount: input.tollCount, tollCountFrom: input.tollCountFrom, tollCountTo: input.tollCountTo, isTruckAllowed: input.isTruckAllowed, isBitrenAllowed: input.isBitrenAllowed, isCurrent: input.isCurrent, isFuture: input.isFuture, executionDate: input.executionDate, executionDateFrom: input.executionDateFrom, executionDateTo: input.executionDateTo, isActive: input.isActive, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: PropertyOriginDestinationExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/geographic/propertyOriginDestinations/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, destinationLocationId: input.destinationLocationId, originLocationId: input.originLocationId, propertyLocationId: input.propertyLocationId, distance: input.distance, distanceFrom: input.distanceFrom, distanceTo: input.distanceTo, unPavedRoadDistance: input.unPavedRoadDistance, unPavedRoadDistanceFrom: input.unPavedRoadDistanceFrom, unPavedRoadDistanceTo: input.unPavedRoadDistanceTo, pavedRoadDistance: input.pavedRoadDistance, pavedRoadDistanceFrom: input.pavedRoadDistanceFrom, pavedRoadDistanceTo: input.pavedRoadDistanceTo, tollCount: input.tollCount, tollCountFrom: input.tollCountFrom, tollCountTo: input.tollCountTo, isTruckAllowed: input.isTruckAllowed, isBitrenAllowed: input.isBitrenAllowed, isCurrent: input.isCurrent, isFuture: input.isFuture, executionDate: input.executionDate, executionDateFrom: input.executionDateFrom, executionDateTo: input.executionDateTo, isActive: input.isActive, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PropertyOriginDestinationDto[]>({
      method: 'GET',
      url: '/api/geographic/propertyOriginDestinations/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: PropertyOriginDestinationUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PropertyOriginDestinationDto>({
      method: 'PUT',
      url: `/api/geographic/propertyOriginDestinations/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}